import './AboutPage.scss'

type Props = {}
const AboutPage = (props: Props) => {
    return (
        <div className="about-pg-container">
            <h1>About Us</h1>
            <div className="motto-image-container">
                <h2>
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit.
                    Ut, distinctio vel laborum veritatis.
                </h2>
                <img src="/images/about-us.jpg" />
            </div>
            <div>
                <h3>Voluptate vero repellat ratione perferendis.</h3>
                <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Vitae nam rerum minus sequi, debitis ipsa deserunt aliquam
                    voluptatem, veritatis dolorum ea error. Temporibus
                    laudantium esse corporis tempora earum possimus quas. Lorem
                    ipsum dolor sit amet consectetur, adipisicing elit. Vitae,
                    vel ut iste nobis sequi enim, nihil harum, architecto optio
                    nesciunt impedit amet deleniti porro veniam itaque. Iusto
                    neque laborum delectus.
                </p>
                <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Temporibus laudantium esse corporis tempora earum possimus
                    quas. Lorem ipsum dolor sit amet consectetur, adipisicing
                    elit. Vitae, vel ut iste nobis sequi enim, nihil harum,
                    architecto optio nesciunt impedit amet deleniti porro veniam
                    itaque. Iusto neque laborum delectus.
                </p>
            </div>
            <div>
                <h3>Qquia aliquam, vero repellat ratione perferendis.</h3>
                <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Vitae nam rerum minus sequi, debitis ipsa deserunt aliquam
                    voluptatem, veritatis dolorum ea error. Temporibus
                    laudantium esse corporis tempora earum possimus quas. Lorem
                    ipsum dolor sit amet consectetur, adipisicing elit. Vitae,
                    vel ut iste nobis sequi enim, nihil harum, architecto optio
                    nesciunt impedit amet deleniti porro veniam itaque. Iusto
                    neque laborum delectus.
                </p>
                <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Temporibus laudantium esse corporis tempora earum possimus
                    quas. Lorem ipsum dolor sit amet consectetur, adipisicing
                    elit. Vitae, vel ut iste nobis sequi enim, nihil harum,
                    architecto optio nesciunt impedit amet deleniti porro veniam
                    itaque. Iusto neque laborum delectus.
                </p>
            </div>

            <div>
                <h3>Thank you for reading us!</h3>

                <p>
                    Lorem ipsum dolor sit, amet consectetur adipisicing elit.
                    Temporibus laudantium esse corporis tempora earum possimus
                    quas. Lorem ipsum dolor sit amet consectetur, adipisicing
                    elit. Vitae, vel ut iste nobis sequi enim, nihil harum,
                    architecto optio nesciunt.
                </p>
            </div>
            <div></div>
        </div>
    )
}
export default AboutPage
